export const USERLOGIN = null;
export const DEALERINFO = null;
export const ADD_TO_BASKET = "ADD_TO_BASKET";
export const ADD_DEPENDECE_TO_BASKET = "ADD_DEPENDECE_TO_BASKET";
export const REMOVE_FROM_BASKET = "REMOVE_FROM_BASKET";
export const REMOVE_DEPENDECE_FROM_BASKET = "REMOVE_DEPENDECE_FROM_BASKET";
export const DELETE_BASKET = "DELETE_BASKET";
export const SET_PRICE = "SET_PRICE";
